import React from "react";

export default function ConfirmModal({ titre, message, confirmLabel, onConfirm, onCancel, danger }) {
  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{titre || "Confirmation"}</h2>
        <p className="muted">{message}</p>
        <div className="modal-actions">
          <button className="secondary" onClick={onCancel}>Annuler</button>
          <button className={danger ? "danger" : ""} onClick={onConfirm}>
            {confirmLabel || "Confirmer"}
          </button>
        </div>
      </div>
    </div>
  );
}
